import React from "react";
import SchoolHeaderImg from "../../../accerts/svg/headers/schoolHeader.svg";
import logo from "../../../accerts/svg/geniuslogo.svg";

const SchoolHeader = ({ data }) => {
  return (
    <div className="Mathheader">
      {" "}
      <img src={logo} className="SchoolheaderLogo schoolheader " alt="LOGO" />
      <img style={{ width: "100%" }} src={SchoolHeaderImg} alt="Header" />
      <p className="SR_SchoolName">{data?.school_name}</p>
      {data && (
        <>
          <p className="SR_Eventinfo">
            {data?.event_scheduled_date_time} | {data?.level} - {data?.round} |{" "}
            {data?.event_mode}
          </p>
        </>
      )}
      <p className="SR_EventName">{data?.event_name} Report</p>
    </div>
  );
};

export default SchoolHeader;
